module.exports = __webpack_public_path__ + "static/media/picture_simic_hover.eed3ea0c.jpg";